import { render, staticRenderFns } from "./AlertUpgrade.vue?vue&type=template&id=5aa25c05"
import script from "./AlertUpgrade.vue?vue&type=script&lang=js"
export * from "./AlertUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports